"use client";

import { OTPContext, OTPContextProvider, OTPContextWrapper } from "@/components/sections/CommonModals/context";
import styles from "./BlogForm.module.scss";
import { useRef } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import BlogConnectModalForm from "@/revamp/molecules/BlogConnectModalForm";
const BlogLeadFormWrapper = ({
    associatedPrograms=[],
    isLambdaAPI=false,
}) => {
    const clickedInsideLeadForm = useRef(false);
  
    const handleClickInsideLeadForm = (e) => {
        if (!clickedInsideLeadForm.current) {
          
          pushToDataLayer(
            {
              event :	"lead_initiate",
              cta_text : "Apply Now",
              section_name : "right_trail_sticky",
              header_title : "NA",
              page_type	: getGlobalStateValue('pageType'),
              page_url : window.location.href || "NA"
            }
          )
          updateStateSession(
            {
              parentSection : "right_trail_sticky"
            }
          )
          clickedInsideLeadForm.current =true;
        }
      };

  return (
        <section className={styles.root} onClick={handleClickInsideLeadForm}>
           <div className={styles.formSection}>
                <OTPContextProvider isLambdaAPI={isLambdaAPI} >
                    <OTPContext.Consumer>
                    {({ isHeaderHidden }) => (
                        <>
                        {!isHeaderHidden && (<p>Apply Now</p>)}
                        <OTPContextWrapper isDarkForm={true}>
                            <BlogConnectModalForm
                                associatedPrograms={associatedPrograms}
                                isNewLeadForm={true}
                            />
                        </OTPContextWrapper>
                        </>
                    )}
                    </OTPContext.Consumer>
                </OTPContextProvider>
            </div>
        </section>
    )
}

export default BlogLeadFormWrapper;
